import { signal } from '@angular/core';

/**
 * Tracks independent asynchronous UI actions without coupling their state to a
 * component-wide loading flag. Callers must always release a started key, such
 * as from an RxJS `finalize` handler.
 */
export class PendingActionTracker<TKey> {
    private readonly pendingKeys = signal<ReadonlySet<TKey>>(new Set<TKey>());

    begin(key: TKey): boolean {
        const pending = this.pendingKeys();
        if (pending.has(key)) {
            return false;
        }

        this.pendingKeys.set(new Set([...pending, key]));
        return true;
    }

    end(key: TKey): void {
        const pending = this.pendingKeys();
        if (!pending.has(key)) {
            return;
        }

        const next = new Set(pending);
        next.delete(key);
        this.pendingKeys.set(next);
    }

    isPending(key: TKey): boolean {
        return this.pendingKeys().has(key);
    }
}
